// extracted by mini-css-extract-plugin
export default {"button":"KeyboardButton_button__+exRU"};